import { apiFetch } from "./api";


export function getWeatherModule(maschineId) {
    return apiFetch(`/maschine/${maschineId}/weather-module`)
}

export function postWeatherModule(maschineId, weatherModule, options) {
    return apiFetch(`/maschine/${maschineId}/weather-module`, {
        method: 'POST',
        body: JSON.stringify({ weatherModule, options: options ?? options })
    })
}